export const ISTITUTIONAL_SITE = 'https://www.ilsole24ore.com/';
export const SOLEPRO_STORE_CODE = '24orepro';

export const BRIGHTCOVE_MERCH_ID = "1231248584001"
export const SOLEPRO_STORE_ID = 7; // Fixed just to avoid another call  because the store is already online.

export const DEFAULT_STORE_CODE = '24orepro';

export const DU_STORE_CODE = 'VP';